// projectSaga.js
import { call, put, takeLatest } from "redux-saga/effects";

import {
  FETCH_PROJECTS_FAILURE,
  FETCH_PROJECTS_REQUEST,
  FETCH_PROJECTS_SUCCESS,
} from "../Actions/Actions";
import Axios from "../../utils/Axios";
import AuthHandler from "../../utils/AuthHandler";
import { navigate } from "../../utils/navigation";
import { FATCH_CLIENT_PROJECTS, FETCH_PROJECTS } from "../../config/API_Collection";
import { getErrorMessage } from "../../config/Error_Codes";

function* fetchProjectsSaga({ payload }) {
  try {
    if (payload?.empid) {
      const response = yield call(Axios.get, `${FATCH_CLIENT_PROJECTS}${payload?.empid}`);
      console.warn(response);

      const projects = response.data.data || [];
      yield put({ type: FETCH_PROJECTS_SUCCESS, payload: projects });
    } else {
      const response = yield call(Axios.get, FETCH_PROJECTS);
      console.warn(response);

      const projects = response.data.data || [];
      yield put({ type: FETCH_PROJECTS_SUCCESS, payload: projects });
    }
  } catch (error) {
    yield call(AuthHandler, error.response?.status, null, navigate);
    yield put({
      type: FETCH_PROJECTS_FAILURE,
      payload: getErrorMessage(error.status),
    });
  }
}

export default function* projectWatcher() {
  yield takeLatest(FETCH_PROJECTS_REQUEST, fetchProjectsSaga);
}
